import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import PaymentCenterPage from "./pages/PaymentCenterPage";
import InvestorTeaserPage from "./pages/InvestorTeaserPage";
import InvestorPortalPage from "./pages/InvestorPortalPage";
import PortfolioPage from "./pages/PortfolioPage";
import SecureCommunicationsPage from "./pages/SecureCommunicationsPage";
import SBAFinancingPage from "./pages/SBAFinancingPage";
import DeployPage from "./pages/DeployPage";
import AdminPortfolioPage from "./pages/AdminPortfolioPage";
import StripeSettingsPage from "./pages/StripeSettingsPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import RefundPolicyPage from "./pages/RefundPolicyPage";
import KycAmlPolicyPage from "./pages/KycAmlPolicyPage";

function InvestorPortalGuard() {
  const hasAccess = localStorage.getItem('sag_investor_access') === 'granted';
  if (!hasAccess) {
    window.location.href = '/investor';
    return null;
  }
  return <InvestorPortalPage />;
}

// Disable PostHog analytics + session replay on sensitive routes so
// credentials, Stripe keys and card entry are never observed.
const SENSITIVE_PATHS = ['/admin', '/payment-center'];
function AnalyticsPrivacyGuard() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window === 'undefined' || !window.posthog) return;
    const sensitive = SENSITIVE_PATHS.some((p) => location.pathname.indexOf(p) === 0);
    try {
      if (sensitive) {
        if (typeof window.posthog.stopSessionRecording === 'function') {
          window.posthog.stopSessionRecording();
        }
        if (typeof window.posthog.opt_out_capturing === 'function') {
          window.posthog.opt_out_capturing();
        }
      } else if (typeof window.posthog.opt_in_capturing === 'function') {
        window.posthog.opt_in_capturing();
      }
    } catch (e) { /* never break the site over analytics */ }
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AnalyticsPrivacyGuard />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/payment-center" element={<PaymentCenterPage />} />
          <Route path="/investor" element={<InvestorTeaserPage />} />
          <Route path="/investor-portal" element={<InvestorPortalGuard />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/secure-communications" element={<SecureCommunicationsPage />} />
          <Route path="/sba-financing" element={<SBAFinancingPage />} />
          <Route path="/deploy" element={<DeployPage />} />
          <Route path="/admin/portfolio" element={<AdminPortfolioPage />} />
          <Route path="/admin/stripe-settings" element={<StripeSettingsPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/refund-policy" element={<RefundPolicyPage />} />
          <Route path="/kyc-aml" element={<KycAmlPolicyPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
